module.exports = __webpack_public_path__ + "img/5.a8fd798b.png";